// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "lara-nesteruk.firebaseapp.com",
  "projectId": "lara-nesteruk",
  "storageBucket": "lara-nesteruk.appspot.com",
  "messagingSenderId": "1063989255524",
  "appId": "1:1063989255524:web:26813cc6df25eeeeb12e71",
  "measurementId": "G-LPTTD90WPN",
  "apiKey": "AIzaSyBJV38p5kRT6hpsIrhPbKxan6XKuUZKZxE"
};
